import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { BaseBreadcrumb } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { FeedForecastsTable } from '@app/components/apps/FeedForecast/AllFeedForecastsTable';

const AllFeedForecasts: React.FC = () => {
  const { setBreadcrumb, addHeaderButton, clearHeaderButtons } = useHeader();
  const navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb(
      <BaseBreadcrumb
        routes={[{ path: `/feed-forescasts`, breadcrumbName: `Feed Forecasts` }]}
        style={{ marginBottom: '15px' }}
      />,
    );

    addHeaderButton(
      'Add Forecast',
      <BaseButton type="primary" size="small" onClick={() => navigate('/add-feed-forecast')}>
        Add Forecast
      </BaseButton>,
    );

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, addHeaderButton, clearHeaderButtons, navigate]);

  return (
    <>
      <PageTitle>Feed Forecasts</PageTitle>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FeedForecastsTable />
        </Col>
      </Row>
    </>
  );
};

export default AllFeedForecasts;
